/**
 * TODO: Function return n first initials of userName
 * @param {number} numElements
 * @param {number} n
 * @param {number} filas
 * @returns string
 */
const calcValue = (numElements, n = 3, filas = 1) =>
  (100 * (numElements / filas)) / n;

export default calcValue;
